import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full space-x-2 flex justify-end" }

import PageWrapper from '@components/page-wrapper/PageWrapper.vue';
import { Table, TableServerDataManager, TableComponentParams } from '@ui-kit/table';
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { CarResource } from '@shared/resources/car';
import { useI18n } from 'vue-i18n';
import { useModalsStore } from '@/stores/modals';
import { CarService } from '@/services/car.service';
import ModalConfirmation from '@components/modals/ModalConfirmation.vue';
import Button from '@ui-kit/controls/button/Button.vue';
import ModalManageClientCar from './modals/ModalManageClientCar.vue';
import { useEmitter } from '@/plugins/mitt/mitt';
import { CarModelResource } from '@shared/resources/car-model';
import { Filters } from '@ui-kit/table/types';
import { getClientName } from '../../../helpers/clients';
import ClientBadge from '../../partials/ClientBadge.vue';
import CarSelect from '../../partials/car-select/CarSelect.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageCars',
  setup(__props) {

const emitter = useEmitter();
const { t } = useI18n();
const modalsStore = useModalsStore();
const carService = new CarService();

const pendingCar = ref<number>();
const tableManager = new TableServerDataManager({
  path: 'cars/grid',
});
const tableParams = computed<TableComponentParams<CarResource>>(() => {
  return {
    columns: [
      {
        name: 'car_model.name',
        data: (row) => {
          const { car_model } = row;
          const { car_brand } = car_model;

          return `${car_brand.name} ${car_model.name}`;
        },
        title: t('fields.car'),
        sortable: true,
        responsiveOrder: 1,
      },
      {
        name: 'registration_plate',
        data: 'registration_plate',
        title: t('fields.registration_plate'),
        sortable: true,
      },
      {
        name: 'client.last_name',
        title: t('fields.client'),
        sortable: true,
      },
      {
        name: 'actions',
        title: '',
        width: 200,
        responsiveOrder: 2,
      },
    ],
  };
});

const selectedCarModel = ref<CarModelResource>();
const tableFilters = computed<Filters>(() => {
  return {
    'car_model.id': selectedCarModel.value ? String(selectedCarModel.value.id) : null,
  };
});
watch(tableFilters, (value) => {
  tableManager.setFilters(value);
});

function removeCar(car: CarResource) {
  modalsStore.addModal({
    component: ModalConfirmation,
    props: {
      title: t('pages.cars.remove-label'),
      danger: true,
      confirmText: t('common.actions.delete'),
      confirm: () => {
        return carService.remove(car.id).send().then(() => {
          tableManager.request();
        });
      },
    },
  });
}
function addCar() {
  modalsStore.addModal({
    component: ModalManageClientCar,
  });
}
async function editCar(car_id: number) {
  pendingCar.value = car_id;
  const { data } = await carService.getById(String(car_id)).send().finally(() => {
    pendingCar.value = undefined;
  });
  modalsStore.addModal({
    component: ModalManageClientCar,
    props: {
      data,
    },
  });
}

function updateTable() {
  tableManager.request();
}
onMounted(() => {
  emitter.on('addCar', updateTable);
  emitter.on('updateCar', updateTable);
});
onBeforeUnmount(() => {
  emitter.off('addCar', updateTable);
  emitter.off('updateCar', updateTable);
});

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createBlock(PageWrapper, {
    title: _ctx.$t('navigation.client-cars')
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Table), {
        "data-manager": _unref(tableManager),
        params: _unref(tableParams)
      }, {
        "header-left": _withCtx(() => [
          _createVNode(CarSelect, {
            class: "w-64",
            modelValue: selectedCarModel.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCarModel).value = $event))
          }, null, 8, ["modelValue"])
        ]),
        "header-right": _withCtx(() => [
          _createVNode(Button, {
            size: "xl",
            "button-type": "outline",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (addCar()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FontAwesomeIcon, {
                icon: "plus",
                class: "mr-2"
              }),
              _createTextVNode(_toDisplayString(_ctx.$t('common.actions.create_new')), 1)
            ]),
            _: 1
          })
        ]),
        "cell-client.last_name": _withCtx(({ row }) => [
          _createVNode(ClientBadge, {
            class: "mr-2",
            type: row.client.type
          }, null, 8, ["type"]),
          _createTextVNode(" " + _toDisplayString(_unref(getClientName)(row.client)), 1)
        ]),
        "cell-actions": _withCtx(({ row }) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(Button, {
              size: "sm",
              onClick: ($event: any) => (editCar(row.id)),
              loading: pendingCar.value === row.id
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FontAwesomeIcon, {
                  icon: "pen",
                  class: "mr-2"
                }),
                _createTextVNode(_toDisplayString(_ctx.$t('common.actions.edit')), 1)
              ]),
              _: 2
            }, 1032, ["onClick", "loading"]),
            _createVNode(Button, {
              size: "sm",
              color: "danger",
              onClick: ($event: any) => (removeCar(row))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FontAwesomeIcon, { icon: "trash" })
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["data-manager", "params"])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})